// import React, { useEffect, useState } from 'react';
// import {
//     Chart as ChartJS,
//     RadialLinearScale,
//     ArcElement,
//     Tooltip,
//     Legend,
// } from 'chart.js';
// import { PolarArea } from 'react-chartjs-2';
// import { logApi } from '../../../api/Api';

// ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend);

// export default function PolarAreaChart() {

//     // dynamically data 

//     const [logData, setLogData] = useState([]);

//     const [credentials, setCredentials] = useState({
//         LOGIN_ID: localStorage.getItem("LoginID"),
//         LOC_CODE: localStorage.getItem("LCODE"),
//         PASS_KEY: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",
//         WEB_KEY: localStorage.getItem("WEB_KEY") || "DEFAULT_WEB_KEY",
//     });


//     const fetchLogData = async () => {
//         const res = await logApi(credentials);
//         if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
//             setLogData(res.TOT_LIVE_KW_NEW);
//         } else {
//             setLogData([]);
//         }
//     };

//     useEffect(() => {
//         fetchLogData();
//     }, [credentials]); // Fetch new data when credentials change



//     const data = {
//         labels: ['Grid: 490.0', 'Solar: 237.0', 'Gen Set: 0.0'],
//         datasets: [
//             {
//                 label: '# of Votes',
//                 data: [50, 40, 30],
//                 backgroundColor: [
//                     '#5D2976',
//                     '#237D29',
//                     '#E3573A',

//                 ],
//                 borderWidth: 1,
//             },
//         ],
//     };


//     return <PolarArea options={{
//         borderColor: "white",
//         responsive: true,
//         maintainAspectRatio: true,
//         spacing: 1,
//         // cutout: 60,
//         aspectRatio: 1.48,
//     }} data={data} />;
// }
import React, { useEffect, useState } from 'react';
import {
    Chart as ChartJS,
    RadialLinearScale,
    ArcElement,
    Tooltip,
    Legend,
} from 'chart.js';
import { PolarArea } from 'react-chartjs-2';
import { logApi } from '../../../api/Api';

ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend);

export default function PolarAreaChart() {
    const [logData, setLogData] = useState([]);
    const [chartData, setChartData] = useState(null);

    // Credentials for the API call
    const [credentials, setCredentials] = useState({
        LOGIN_ID: localStorage.getItem('LoginID'),
        LOC_CODE: localStorage.getItem('LCODE'),
        PASS_KEY: localStorage.getItem('PASS_KEY') || 'DEFAULT_PASS_KEY',
        WEB_KEY: localStorage.getItem('WEB_KEY') || 'DEFAULT_WEB_KEY',
    });

    // Fetch data from the API
    const fetchLogData = async () => {
        try {
            const res = await logApi(credentials);
            if (res?.TOT_LIVE_KW_NEW && Array.isArray(res.TOT_LIVE_KW_NEW)) {
                setLogData(res.TOT_LIVE_KW_NEW);
            } else {
                setLogData([]);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    // Transform fetched data into chart-ready format
    useEffect(() => {
        if (logData.length > 0) {
            const labels = ['Grid', 'Solar', 'Gen Set'];
            const dataValues = logData.map((item) => [
                item.GRID ?? 0,
                item.SOLAR ?? 0,
                item.GenSet ?? 0,
            ]);

            // Flatten the dataValues array if multiple records exist
            const totalData = dataValues.flat();

            setChartData({
                labels: labels,
                datasets: [
                    {
                        label: 'Energy Sources (kW)',
                        data: totalData,
                        backgroundColor: ['#5D2976', '#237D29', '#E3573A'], // Color for Grid, Solar, GenSet
                        borderWidth: 1,
                        hoverOffset: 4, // Make it more interactive
                    },
                ],
            });
        }
    }, [logData]);

    // Fetch data on component mount
    useEffect(() => {
        fetchLogData();
    }, [credentials]);

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'right',
                alignItems: 'center',
             padding:"9px 0px 9px 140px"
            }}
        >
            {chartData ? (
                <PolarArea
                    options={{
                        responsive: true,
                        maintainAspectRatio: true,
                        plugins: {
                            legend: {
                                position: 'top',
                                labels: {
                                    generateLabels: (chart) => {
                                        const labels = chart.data.labels || [];
                                        const datasets = chart.data.datasets || [];
                                        return labels.map((label, i) => {
                                            const dataset = datasets[0];
                                            const value = dataset.data[i] || 0;
                                            return {
                                                text: `${label}: ${value} kW`,
                                                fillStyle: dataset.backgroundColor[i],
                                                strokeStyle: dataset.borderColor || 'black',
                                                lineWidth: 2,
                                            };
                                        });
                                    },
                                },
                            },
                            tooltip: {
                                callbacks: {
                                    label: (context) => {
                                        const label = context.label || '';
                                        const value = context.raw || 0;
                                        return `${label}: ${value} kW`; // Display value in tooltip
                                    },
                                },
                            },
                        },
                    }}
                    data={chartData}
                />
            ) : (
                <p>Loading chart...</p>
            )}
        </div>
    );
}
